import "./DesktopFineTable.css";

import { Col, IDFines } from "../../../models/fineModels";
import {
  faAngleDown,
  faCaretDown,
  faCaretUp,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import ReCaptcha from 'react-google-recaptcha'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "../../../hooks/reduxHooks";
import appConfig from "../../../config";
interface DesktopFineTableProps {
  handleInfringement: (infringement: string, token: string, version: boolean) => Promise<true | undefined>;
}

const DesktopFineTable = ({ handleInfringement }: DesktopFineTableProps) => {
  const data = useAppSelector((state) => state.fine.idFines);


  const onContinueClicked = (account: string, token: string, version: boolean) => {
    handleInfringement(account, token, version);
  };

  const [fines, setFines] = useState<IDFines[] | null>(data);
  const [isAscending, setIsAscending] = useState<boolean>(false);
  const [sortedColumn, setSortedColumn] = useState<Col | null>(null);
  const [limit, setLimit] = useState<number>(10);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [visibleToken, setVisibleToken] = useState<any>(false);
  const captchaRef = useRef<any>(null);
  const [numberTries, setNumberTries] = useState(1)
  const APIKEY = numberTries % 3 !== 0 ? appConfig.recaptchaSiteKey : appConfig.recpatchaSiteKeyv2;

  useEffect(() => {
    setFines(data);
  }, [data]);

  let columns: Col[] = [
    { title: "Traffic Notice", accessor: "noticeNumber" },
    {
      title: "Amount",
      accessor: "amount",
    },
    {
      title: "Offense Date",
      accessor: "offenceDate",
    },
    {
      title: "Due Date",
      accessor: "dueDate",
    },
    {
      title: "Status",
      accessor: "warrantOfArrestPending",
    },
    {
      title: "Action",
      accessor: "action",
    },
  ];

  const handleExecuteRecaptcha = async (submitted = true, noticeNumber: string = '') => {
    let token: string;

    if (captchaRef.current != null) {
      if (submitted) {
        token = await captchaRef.current?.executeAsync();
      } else {
        token = await captchaRef.current.getValue();

      }

      setNumberTries(numberTries + 1)
      setDisabled(false)
    if (submitted) {
      await onContinueClicked(noticeNumber, token, (numberTries) % 3 !== 0)
    } else {
      setVisibleToken({token, version:(numberTries) % 3 !== 0})
    }
    }
  }

  const onHeaderItemClicked = (col: Col) => {
    setIsAscending(true);
    setSortedColumn(col);
    if (sortedColumn && isAscending) setIsAscending(false);
    let accessor = sortedColumn?.accessor as keyof IDFines;
    let sortedFines = fines;
    if (sortedFines) {
      sortedFines = sortedFines?.slice().sort((a: IDFines, b: IDFines) => {
        if (a && b && accessor) {
          if (a[accessor] < b[accessor]) {
            return isAscending ? 1 : -1;
          }
          if (a[accessor] > b[accessor]) {
            return isAscending ? -1 : 1;
          }
        }
        return 0;
      });
      setFines(sortedFines);
    }
  };

  const onLoadMoreClicked = () => {
    setLimit(limit + 10);
  };

  return (
    <div className="desktop-table-container">
      <table className="desktop-table">
        <thead className="table-header">
          <tr>
            {columns.map((col, index) => (
              <td
                key={index}
                style={{
                  width: "15%",
                  cursor:
                    col !== columns[0] &&
                    col !== columns[5] &&
                    col.title !== " "
                      ? "pointer"
                      : "inherit",
                }}
                onClick={() =>
                  col !== columns[0] &&
                  col !== columns[5] &&
                  onHeaderItemClicked(col)
                }
              >
                {col.title}
                {sortedColumn && col.title === sortedColumn.title ? (
                  <FontAwesomeIcon
                    icon={isAscending ? faCaretUp : faCaretDown}
                    size="1x"
                    color="white"
                    style={{ marginLeft: 10 }}
                  />
                ) : index !== 0 &&
                  index !== 5 &&
                  col.title !== sortedColumn?.title ? (
                  <FontAwesomeIcon
                    icon={faSort}
                    size="1x"
                    color="white"
                    className="sort-icon"
                    style={{ marginLeft: 10, height: 14 }}
                  />
                ) : null}
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          {fines
            ?.slice(0, limit < fines.length ? limit : fines.length)
            .map((fine, index) => (
              <tr key={index}>
                <td>{fine.noticeNumber}</td>
                <td>R{fine.amount / 100}</td>
                <td>{fine.offenceDate}</td>
                <td>{fine.dueDate}</td>
                <td>
                  <div
                    className="status-container"
                    style={{
                      backgroundColor: fine.warrantOfArrestPending
                        ? "#D7D7D7"
                        : "#ECECEC",
                    }}
                  >
                    <p>
                      {" "}
                      {fine.warrantOfArrestPending ? "Warrant" : "Active Fine"}
                    </p>
                  </div>
                </td>
                <td>
                  <div
                    className="continue-to-fine-button"
                    onClick={() => {
                      if (!visibleToken) {
                        handleExecuteRecaptcha(true, fine.noticeNumber);
                      } else {
                        onContinueClicked(fine.noticeNumber, visibleToken.token, visibleToken.version);
                      }
                    }}
                  >
                    <p>Continue</p>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {fines && limit < fines?.length ? (
        <div
          className="load-more-fines-button"
          onClick={() => onLoadMoreClicked()}
        >
          <p>Load More</p>
          <FontAwesomeIcon
            icon={faAngleDown}
            size="1x"
            color="#18283c"
            style={{ marginLeft: 10 }}
          />
        </div>
      ) : null}
      {numberTries % 3 !== 0 ? (<>
        <ReCaptcha
            theme="light"
            size={"invisible"}
            ref={captchaRef}
            sitekey={APIKEY}
        />
      </>) : (
          <ReCaptcha
              size={"normal"}
              ref={captchaRef}
              style={{marginTop: 10}}
              sitekey={APIKEY}
              onChange={(e: any) => handleExecuteRecaptcha(false)}
          />
      )}
    </div>
  );
};

export default DesktopFineTable;
